import { memo } from 'react';

import ArrowTriangleIconSVG from '@/assets/arrow-triangle-icon.svg?react';
import { merge } from '@/components';
import { Icon, IconProps } from '@/components/core';

export type ArrowTriangleIconProps = Omit<IconProps, 'SVGComponent'> & {
  rotation: 'up' | 'right' | 'down' | 'left';
};

const IArrowTriangleIcon = ({ rotation, className, ...rest }: ArrowTriangleIconProps) => {
  /* prettier-ignore */
  const rotationStyles = [
    rotation === 'up' && 'rotate-270',
    rotation === 'right' && 'rotate-0',
    rotation === 'down' && 'rotate-90',
    rotation === 'left' && 'rotate-180',
  ];

  return <Icon SVGComponent={ArrowTriangleIconSVG} className={merge(rotationStyles, className)} {...rest} />;
};

export const ArrowTriangleIcon = memo(IArrowTriangleIcon) as typeof IArrowTriangleIcon;
